import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteMonitoringRecord = () => {
  const { authHeader } = useAuth();

  return useMutation((params: any) => {
    return axios.delete(`${env.verifyServiceUrl}individual/monitoring/${params.id}/`, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
